"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const StatusBarConstants_1 = require("./StatusBarConstants");
const StatusBarProgressBar_1 = tslib_1.__importDefault(require("./StatusBarProgressBar"));
const StatusBarIcon_1 = tslib_1.__importDefault(require("./StatusBarIcon"));
const StatusBarLabel_1 = tslib_1.__importDefault(require("./StatusBarLabel"));
const iconDefaults = { name: '', alignment: StatusBarConstants_1.LEFT };
const labelDefaults = { value: '', alignment: StatusBarConstants_1.RIGHT, weight: StatusBarConstants_1.BOLD };
const StatusBar = (props) => {
    const { progress = [], size = StatusBarConstants_1.SMALL, className = '', useProgressDivider = true } = props;
    // deep destructuring with merging default props don't work
    const icon = Object.assign(Object.assign({}, iconDefaults), props.icon);
    const label = Object.assign(Object.assign({}, labelDefaults), props.label);
    const hasIcon = !!icon.name;
    const iconIsLeft = icon.alignment === StatusBarConstants_1.LEFT;
    const iconIsRight = icon.alignment === StatusBarConstants_1.RIGHT;
    const hasLabel = !!label.value;
    const labelIsLeft = label.alignment === StatusBarConstants_1.LEFT;
    const labelIsTop = label.alignment === StatusBarConstants_1.TOP;
    const labelIsRight = label.alignment === StatusBarConstants_1.RIGHT;
    const hasOnlyIcon = hasIcon && !hasLabel;
    const hasOnlyLabel = !hasIcon && hasLabel;
    const hasIconAndLabel = hasIcon && hasLabel;
    const isIconLeftAndLabelRight = hasIconAndLabel && iconIsLeft && labelIsRight;
    const isIconRightAndLabelLeft = hasIconAndLabel && iconIsRight && labelIsLeft;
    const isIconAndLabelLeft = hasIconAndLabel && iconIsLeft && labelIsLeft;
    const isIconAndLabelRight = hasIconAndLabel && iconIsRight && labelIsRight;
    const isIconOnlyLeft = hasOnlyIcon && iconIsLeft;
    const isIconOnlyRight = hasOnlyIcon && iconIsRight;
    const isLabelOnlyLeft = hasOnlyLabel && labelIsLeft;
    const isLabelOnlyRight = hasOnlyLabel && labelIsRight;
    const wrapperClasses = (0, classnames_1.default)('StatusBar', 'width-100pct', 'display-flex', labelIsTop ? 'align-items-end' : 'align-items-center', className);
    const progressLabelWrapperClasses = (0, classnames_1.default)('display-flex', 'flex-1-0', {
        'flex-order-1 flex-column margin-bottom-10': labelIsTop,
        'flex-order-1 align-items-center': isIconAndLabelRight || isIconRightAndLabelLeft || isIconOnlyRight,
        'flex-order-2 align-items-center': isIconAndLabelLeft || isIconLeftAndLabelRight || isIconOnlyLeft,
        'align-items-center': isLabelOnlyLeft || isLabelOnlyRight,
    });
    const labelWrapperClasses = (0, classnames_1.default)({
        'display-flex justify-content-center': labelIsTop,
        'flex-order-1 margin-right-10': isIconAndLabelLeft || isIconRightAndLabelLeft || isLabelOnlyLeft,
        'flex-order-2 margin-left-10': isIconAndLabelRight || isIconLeftAndLabelRight || isLabelOnlyRight,
    });
    const progressOuterWrapperClasses = (0, classnames_1.default)('display-flex', 'flex-1-0', {
        'flex-order-2': isIconAndLabelLeft || isIconRightAndLabelLeft || isLabelOnlyLeft,
        'flex-order-1': isIconAndLabelRight || isIconLeftAndLabelRight || isLabelOnlyRight,
    });
    const progressWrapperClasses = (0, classnames_1.default)('progress', 'margin-0', 'flex-1-0', {
        'height-5': size === StatusBarConstants_1.SMALL,
        'height-10': size === StatusBarConstants_1.LARGE,
    });
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: wrapperClasses }, { children: [(0, jsx_runtime_1.jsx)(StatusBarIcon_1.default, { icon: icon, size: size }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: progressLabelWrapperClasses }, { children: [(0, jsx_runtime_1.jsx)(StatusBarLabel_1.default, { label: label, size: size, className: labelWrapperClasses }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: progressOuterWrapperClasses }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: progressWrapperClasses }, { children: progress.map((item, index) => ((0, jsx_runtime_1.jsx)(StatusBarProgressBar_1.default, { progress: item, index: index, useProgressDivider: useProgressDivider }, index))) })) }))] }))] })));
};
exports.default = StatusBar;
